

















































































































































































































































































































































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import UserApi from '@/api/user'
import PartnerApi from '@/api/partner'
import cloneDeep from 'lodash/cloneDeep'
import PageLayout from '@/components/page/PageLayout.vue'
import isEmpty from 'lodash/isEmpty'
import listMixins from '@/mixins/list'
import VisitorsApi from '@/api/visitor'
import { download } from '@/utils/util'
import { TOKEN } from '@/store/mutation-types'
import SaveVisitor from './SaveVisitor.vue'

@Component({
	name: 'partnerVisitorList',
	components: {
		PageLayout,
		SaveVisitor,
	},
})
export default class UsersList extends Mixins(listMixins) {
	visible: boolean = false
	modVisible: boolean = false

	private addForm: any = {}
	private modForm: any = {}
	private exportingList: boolean = false
	private companyOptions: any = []
	private uploadPath: any =
		process.env.VUE_APP_API_KEY + 'injury/visitor/import'
	private headers: any = {
		[TOKEN]: this.$ls.get(TOKEN),
	}
	private uploading: boolean = false
	private columns: any = [
		{
			title: '序号',
			key: 'order',
			dataIndex: 'order',
			align: 'center',
			width: 40,
			scopedSlots: { customRender: 'order' },
		},
		{
			title: '作业人员工号',
			dataIndex: 'jobNumber',
			align: 'center',
			width: 80,
		},
		{
			title: '姓名',
			align: 'center',
			dataIndex: 'name',
		},
		{
			title: '电话',
			align: 'center',
			dataIndex: 'mobile',
		},
		{
			title: '年龄',
			align: 'center',
			dataIndex: 'age',
		},
		{
			title: '性别',
			align: 'center',
			dataIndex: 'sex',
		},
		// {
		// 	title: '学历',
		// 	align: 'center',
		// 	dataIndex: 'education',
		// 	scopedSlots: { customRender: 'education' },
		// },
		// {
		// 	title: '政治面貌',
		// 	align: 'center',
		// 	dataIndex: 'politics',
		// 	scopedSlots: { customRender: 'politics' },
		// },
		{
			title: '职业',
			align: 'center',
			dataIndex: 'career',
			scopedSlots: { customRender: 'career' },
		},
		{
			title: '头像',
			align: 'center',
			dataIndex: 'hasPic',
			scopedSlots: { customRender: 'hasPic' },
		},
		{
			title: '资源公司',
			align: 'center',
			dataIndex: 'company',
			width: 100,
		},
		{
			title: '所在地区',
			align: 'center',
			dataIndex: 'fullDesc',
			width: 200,
		},
		{
			title: '作业人员角色',
			align: 'center',
			dataIndex: 'roleName',
		},
		{
			title: '管理地区',
			align: 'center',
			dataIndex: 'manageAreas',
			scopedSlots: { customRender: 'manageAreas' },
		},
		{
			title: '完成订单数',
			align: 'center',
			dataIndex: 'finishCount',
		},
		{
			title: '平均完成时长',
			align: 'center',
			dataIndex: 'avgFinishTime',
		},
		{
			title: '综合评分',
			align: 'center',
			dataIndex: 'score',
		},
		{
			title: '作业状态',
			align: 'center',
			dataIndex: 'examStatus',
			scopedSlots: { customRender: 'examStatus' },
		},
		{
			title: '账号状态',
			align: 'center',
			dataIndex: 'status',
			scopedSlots: { customRender: 'status' },
		},
		{
			title: '锁定',
			align: 'center',
			dataIndex: 'updateLocked',
			scopedSlots: { customRender: 'updateLocked' },
		},
		{
			title: '功能',
			align: 'center',
			dataIndex: 'action',
			scopedSlots: { customRender: 'action' },
		},
	]

	data: any[] = []
	timer: any = ''
	visitorRoles: any = []

	addLoading: boolean = false
	modLoading: boolean = false

	reasonForm: any = {}
	visibleReason: boolean = false

	public created() {
		this.addForm = this.$form.createForm(this)
		this.modForm = this.$form.createForm(this)
		this.reasonForm = this.$form.createForm(this)
		this.getVisitorRoles()
	}

	public activated() {
		this.$store.dispatch('setting/initPartnerTree')
		this.$store.dispatch('setting/initAreas')
		this.getList()
	}

	public getList() {
		const form = this.getSearchValues()
		return VisitorsApi.getVisitorList(form).then((data: any) => {
			this.data = data.data.retList
			this.total = data.data.count
			this.resetSelected()
		})
	}

	private getVisitorRoles() {
		UserApi.getRoles({
			filterbyType: 0,
			where: 2,
		}).then((res: any) => {
			this.visitorRoles = res.data.filter((item: any) => {
				return item.code && item.code > '41000'
			})
		})
	}

	private doMod() {
		this.modForm.validateFields((err: any, values: any) => {
			if (!err) {
				const selected: any = this.selected[0]
				const copy: any = {}
				copy.name = values.name
				copy.mobile = values.mobile
				this.modLoading = true
				VisitorsApi.updateVisitor(copy)
					.then((res: any) => {
						this.$message.success('更新成功')
						this.modVisible = false
						this.getList()
					})
					.finally(() => {
						this.modLoading = false
					})
			}
		})
	}

	private onSave() {
		this.getList()
	}

	private doAdd() {
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.addLoading = true
				values = cloneDeep(values)
				VisitorsApi.addVisitor(values)
					.then((res: any) => {
						this.$message.success('添加用户成功')
						this.visible = false
						this.resetPage()
						this.getList()
					})
					.finally(() => {
						this.addLoading = false
					})
			}
		})
	}

	private modifyInfo() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			if (selected.updateLocked) {
				this.$message.error('账号已锁定，请先解锁账号')
				return
			}
			this.modVisible = true
		}
	}

	private enable() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: '提示',
				content: '确认启用吗 ?',
				onOk: () => {
					const form = {
						visitorId: selected.id,
					}
					return VisitorsApi.activeVisitor(form).then((res: any) => {
						this.$message.success('启用成功')
						this.getList()
					})
				},
			})
		}
	}

	private disable() {
		if (this.checkSelected()) {
			this.visibleReason = true
			// const selected = this.selected[0]
			// const form = {
			// 	visitorId: selected.id,
			// }
			// this.$confirm({
			// 	title: '提示',
			// 	content: '确认停用吗 ?',
			// 	onOk: () => {
			// 		const form = {
			// 			visitorId: selected.id,
			// 		}
			// 		return VisitorsApi.inactiveVisitor(form).then((res: any) => {
			// 			this.$message.success('停用成功')
			// 			this.getList()
			// 		})17213487129
			// 	},
			// })
		}
	}

	private handleCancel() {
		this.visibleReason = false
	}
	private handleOk() {
		this.reasonForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.visibleReason = true
				const selected = this.selected[0]
				const form = {
					visitorId: selected.id,
					reason: values.reason,
				}
				VisitorsApi.inactiveVisitor(form)
					.then((res: any) => {
						this.$message.success('停用成功')
						this.visibleReason = false
						this.getList()
					})
					.finally(() => {
						this.visibleReason = false
					})
			}
		})
	}

	private enableOperation() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			const form = {
				visitorId: selected.id,
			}
			return VisitorsApi.activeOperation(form).then((res: any) => {
				this.$message.success('开启作业状态成功')
				this.getList()
			})
		}
	}

	private disableOperation() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			const form = {
				visitorId: selected.id,
			}
			return VisitorsApi.inactiveOperation(form).then((res: any) => {
				this.$message.success('取消作业状态成功')
				this.getList()
			})
		}
	}

	private lockClick(type: string) {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: type == 'locking' ? '锁定提示' : '解锁提示',
				content:
					type == 'locking' ? '请确认是否锁定此账号?' : '请确认是否解锁此账号?',
				onOk: () => {
					const form = {
						visitorId: selected.id,
					}
					if (type == 'locking') {
						return VisitorsApi.locked(form).then((res: any) => {
							this.$message.success('锁定成功')
							this.getList()
						})
					} else {
						return VisitorsApi.unLocked(form).then((res: any) => {
							this.$message.success('解锁成功')
							this.getList()
						})
					}
				},
			})
		}
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择用户')
			return false
		}
		return true
	}

	private addNewUser() {
		this.visible = true
	}

	private exportList() {
		this.exportingList = true
		PartnerApi.exportVisitor(this.getSearchValues())
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	private uploadChange(info: any) {
		const file: any = info.file
		if (file.status === 'done') {
			this.uploading = false
		} else {
			this.uploading = true
		}
		if (file.status === 'done') {
			if (file.response.code === 200) {
				this.$message.success(`${file.name} 上传成功`)
			} else {
				this.$message.error(
					file.response.message || `${file.name} 上传失败 ${file.response.data}`
				)
			}
		}
	}
}
